import { Instagram, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/shared";
import { INSTAGRAM_URL, INSTAGRAM_HANDLE } from "@/lib/site";

const GRID = [
  { url: "/images/instagram/post-1.jpg", alt: "Post do Instagram: Engenharia que cuida do seu patrimônio — trabalho em altura" },
  { url: "/images/instagram/post-2.jpg", alt: "Post do Instagram: Ampliação do Sistema Carcerário de Sapucaia" },
  { url: "/images/instagram/post-3.jpg", alt: "Post do Instagram: Bom dia — Hotel Intercity Cidade Baixa, Porto Alegre" },
  { url: "/images/instagram/post-4.jpg", alt: "Post do Instagram: Terraplanagem e preparação de base — Sistema Carcerário de Sapucaia" },
  { url: "/images/instagram/post-5.jpg", alt: "Post do Instagram: Solicite sua Visita Técnica — Realiza Engenharia" },
];

export default function InstagramFeed() {
  return (
    <section className="py-24">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <SectionHeading
            eyebrow="Instagram"
            title={<>A Realiza <span className="text-gold-grad">no Instagram</span></>}
          />
          <Reveal delay={0.15}>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="instagram-follow-button"
              className="inline-flex items-center gap-2 rounded-full border border-gold/40 px-6 py-3 font-display text-sm font-bold tracking-[0.12em] text-gold transition-all duration-300 hover:bg-gold hover:text-navy-950"
            >
              <Instagram className="h-4 w-4" /> SEGUIR {INSTAGRAM_HANDLE.toUpperCase()} <ArrowUpRight className="h-4 w-4" />
            </a>
          </Reveal>
        </div>
        <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
          {GRID.map((img, i) => (
            <Reveal key={img.url} delay={i * 0.06}>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`instagram-post-${i}`}
                aria-label={`Publicação da Realiza Engenharia no Instagram ${i + 1}`}
                className="group relative block aspect-[3/4] overflow-hidden border border-white/[0.07] bg-navy-800"
              >
                <img src={img.url} alt={img.alt} loading="lazy" className="h-full w-full object-contain transition-transform duration-700 group-hover:scale-[1.04]" />
                <span className="absolute inset-0 flex items-center justify-center bg-navy-950/60 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <Instagram className="h-6 w-6 text-gold" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
